module.exports = __webpack_public_path__ + "static/media/age_descrimination.67aa5f0c.webp";